import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/layout";
import { Helmet } from "react-helmet-async";

function Contact() {

    const [fullName, setFullName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [mobileNo, setMobileNo] = React.useState("");
    const [subject, setSubject] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [errorMessage, setErrorMessage] = React.useState("");

    return (
        <>
        <Helmet>
                    <title>Contact Us | Adilite Group</title>
        
                    <meta name="description" content="Welcome to Adilite Group, the leading provider of high-quality measurement and testing products. We specialize in offering a comprehensive range of instruments and tools designed to meet the need of various industries, including manufacturing, construction, engineering and research." />
                    <meta
                    name="keywords"
                    content="Power Transformer, Electrical Equipment, Transformer, Secure Meters"
                    />
                    <meta name="robots" content="index,follow" />
        
                    <link rel="canonical" href="https://www.adilitegroups.com/contact" />
        
                    {/* Open Graph */}
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content="Contact Us | Adilite Group" />
                    <meta property="og:description" content="Welcome to Adilite Group, the leading provider of high-quality measurement and testing products. We specialize in offering a comprehensive range of instruments and tools designed to meet the need of various industries, including manufacturing, construction, engineering and research." />
                    <meta property="og:url" content="https://www.adilitegroups.com/contact" />
                </Helmet>
        <Layout>
            <div>
                <div id="banner-area" className="banner-area" style={{ backgroundImage: 'url(assets/images/banner/banner1.jpg)' }}>
                    <div className="banner-text">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="banner-heading">
                                        <h1 className="banner-title">Contact Us</h1>
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb justify-content-center">
                                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                                <li className="breadcrumb-item"><a href="/">ADILITE GROUP</a></li>
                                                <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>{/* Col end */}
                            </div>{/* Row end */}
                        </div>{/* Container end */}
                    </div>{/* Banner text end */}
                </div>{/* Banner area end */}
                <section id="main-container" className="main-container">
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-12">
                                <h2 className="section-title">Reaching our Office</h2>
                                <h3 className="section-sub-title">Find Our Location</h3>
                            </div>
                        </div>
                        {/*/ Title row end */}
                        <div className="row">
                            <div className="col-md-4">
                                <div className="ts-service-box-bg text-center h-100">
                                    <span className="ts-service-icon icon-round">
                                        <i className="fas fa-map-marker-alt mr-0" />
                                    </span>
                                    <div className="ts-service-box-content">
                                        <h4>Visit Our Office</h4>
                                        <p>H.No. 4-14-193, Ground Floor, Laxmi Nagar, West Marredpally, Secunderabad - 500026</p>
                                    </div>
                                </div>
                            </div>{/* Col 1 end */}
                            <div className="col-md-4">
                                <div className="ts-service-box-bg text-center h-100">
                                    <span className="ts-service-icon icon-round">
                                        <i className="fa fa-envelope mr-0" />
                                    </span>
                                    <div className="ts-service-box-content">
                                        <h4>Email Us</h4>
                                        <p>adilitegroup@gmail.com</p>
                                    </div>
                                </div>
                            </div>{/* Col 2 end */}
                            <div className="col-md-4">
                                <div className="ts-service-box-bg text-center h-100">
                                    <span className="ts-service-icon icon-round">
                                        <i className="fa fa-phone-square mr-0" />
                                    </span>
                                    <div className="ts-service-box-content">
                                        <h4>Call Us</h4>
                                        <p>(+91) 9000-123-060</p>
                                    </div>
                                </div>
                            </div>{/* Col 3 end */}
                        </div>{/* 1st row end */}
                        <div className="gap-60" />
                        <div className="google-map">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1889.918755111348!2d78.50356111292835!3d17.453570638766845!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9a4749a9c70b%3A0x692e4412aa2ad579!2sLakshmi%20Nagar%2C%20West%20Marredpally%2C%20Secunderabad%2C%20Telangana%20500026!5e0!3m2!1sen!2sin!4v1719915581214!5m2!1sen!2sin" width="100%" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>                        
                        </div>
                        <div className="gap-40" />
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="column-title">We love to hear</h3>
                                {/* contact form works with formspree.io  */}
                                {/* contact form activation doc: https://docs.themefisher.com/constra/contact-form/ */}
                                <div>
                                    <div className="error-container" />
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Name</label>
                                                <input className="form-control form-control-name" value={fullName} onChange={(e)=>setFullName(e.target.value)} name="name" id="name" placeholder type="text" required />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Mobile No.</label>
                                                <input className="form-control form-control-email" value={mobileNo} onChange={(e)=>setMobileNo(e.target.value)} name="email" id="email" placeholder type="number" required />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Email</label>
                                                <input className="form-control form-control-email" value={email} onChange={(e)=>setEmail(e.target.value)} name="email" id="email" placeholder type="email" required />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Subject</label>
                                                <input className="form-control form-control-subject" value={subject} onChange={(e)=>setSubject(e.target.value)} name="subject" id="subject" placeholder required />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Message</label>
                                        <textarea className="form-control form-control-message" value={message} onChange={(e)=>setMessage(e.target.value)} name="message" id="message" placeholder rows={10} required defaultValue={""} />
                                    </div>
                                    <div className="text-right"><br />
                                        <button className="btn btn-primary solid blank" type="submit" onClick={()=>{
                                            if(fullName !== "" && email !== "" && subject !== "" && message !== "" && mobileNo !=="")
                                                {
                                                    const phone = "919000123060"; // Country code + phone number (no + or spaces)
                            
                                                    const whatsappMessage = `*New Contact Inquiry*\n\n*Name:* ${fullName}\n*Email:* ${email}\n*Mobile No:* ${mobileNo}\n*Subject:* ${subject}\n*Message:* ${message}`;

                                                    const url = `https://wa.me/${phone}?text=${encodeURIComponent(whatsappMessage)}`;

                                                    window.open(url, "_blank");

                                                }
                                                else
                                                {
                                                    setErrorMessage("Enter all valid fields.");
                                                }
                                        }}>Send Message</button>
                                        <div style={{ color: "#FF0000" }}>
                                            {errorMessage}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>{/* Content row */}
                    </div>{/* Conatiner end */}
                </section>{/* Main container end */}
            </div>
            <h5 style={{ color: "#fff", fontSize: 0.1 }}>
                Welcome to Adilite Group, the leading provider of high-quality measurement and testing products. We specialize in offering a comprehensive range of instruments and tools designed to meet the need of various industries, including manufacturing, construction, engineering and research.
                Testing instruments, Measuring instruments, Measurement tools, Testing equipment, Calibration equipment, Specific Instrument Keywords,Multimeters,Oscilloscopes,Pressure gauges,Thermometers, Anemometers, Calipers,pH meters,Data loggers,Spectrum analyzers, Electrical testing instruments, HVAC measuring tools, Laboratory testing equipment, Industrial measurement devices, Environmental testing instruments,Precision measuring instruments,Digital testing tools,Analog measurement tools,Portable testing equipment,Handheld measuring devices,Fluke testing instruments,Extech measuring tools,Tektronix oscilloscopes,Mitutoyo calipers,Keysight measurement devices,High accuracy testing instruments,Wireless measuring devices,Waterproof measuring tools,Multifunction testing equipment, User-friendly measurement tools, How to measure voltage, Best tools for measuring pressure, Accurate temperature measurement devices, Reliable pH testing equipment, Affordable testing instruments, Testing instruments suppliers near me, Measuring tools dealer in hyderabad, andhra pradesh, telangana, bangalore, mumbai, pune, vijaywada, vishakhapatnam, Local calibration equipment services, Nearest industrial testing instruments store, Find pH meters in hyderabad, andhra pradesh, telangana, bangalore, mumbai, pune, vijaywada, vishakhapatnam
                Authorised Secure dealer of APEX 100,Apex 150_R01,Elite 100 & 300 MFM New,Elite 440 New,Elite 500 -Power Monitoring Meter,Liberty 170,Liberty 370,M-cubed_100,premier_300,Prodigy new,ProQ_100,PT1_single function transducer,Saral, saral-300, sprint 350, summator 100, transducerPT1-multi, transducerPT3-multi
            </h5>
        </Layout>
        </>
    );
}

export default Contact;
